<form [formGroup]="timeForm">
    <div class="input-wrapper time-input">
        <app-bciti-time-input
            [label]="'pages.services-state.dialogs.service-schedule-dialog.intervals.from.label' | translate"
            formControlName="from"
        >
            <app-form-error *ngIf="fromTime.touched && fromTime.hasError('required')">
                {{ 'pages.services-state.dialogs.service-schedule-dialog.intervals.from.errors.required' | translate }}
            </app-form-error>
        </app-bciti-time-input>
        <app-bciti-time-input
            [label]="'pages.services-state.dialogs.service-schedule-dialog.intervals.to.label' | translate"
            formControlName="to"
            (change)="onToTimeChange()"
        >
            <app-form-error *ngIf="toTime.touched && toTime.hasError('required')">
                {{ 'pages.services-state.dialogs.service-schedule-dialog.intervals.to.errors.required' | translate }}
            </app-form-error>
        </app-bciti-time-input>
        <button *ngIf="closeable" class="close-btn" type="button" (click)="cancelCreateAction()">
            <span class="icon icon-close"></span>
        </button>
    </div>
</form>